import ReactModal from 'react-modal'
import React from "react";
import { createPortal } from "react-dom";
// @ts-ignore
import css from "../index.css?inline";

/**
 * A modal which puts its contents into shadow dom.
 * 
 * Useful if your whole application is running in shadow dom and you want your styles there instead of host styles.
 * @param {*} props Given props are passed to ReactModal
 * @returns 
 */
export default function ShadowModal(props: ReactModal.Props) {
    return (
    <ReactModal {...props} >
        <ShadowDom>
            {props.children}
        </ShadowDom>
    </ReactModal>
    )
}

interface ShadowDomProps {
    children: any
}

// from https://gist.github.com/just-boris/1bf296c887066861ef9dda38eb5cca84
class ShadowDom extends React.Component<ShadowDomProps> {
    ref = React.createRef<HTMLDivElement>();
    state: {shadowRoot?: any} = {};

  componentDidMount() {
    if (this.ref.current == null) {
        console.warn("No ref for shadow modal")
        return
    }

    const shadowRoot = this.ref.current.attachShadow({ mode: "open" });

    const style = document.createElement('style')
    // css could be passed as style or something but this is what I want now
    style.textContent = css
    shadowRoot.appendChild(style)

    this.setState({ shadowRoot });
  }

  render() {
    return (
      <div ref={this.ref}>
        {this.state.shadowRoot
          ? createPortal(this.props.children, this.state.shadowRoot)
          : null}
      </div>
    );
  }
}